// extracted by mini-css-extract-plugin
module.exports = {"redirectButton":"styles_redirectButton__JuJHh","pageWrapper":"styles_pageWrapper__0sKxV","pageForm":"styles_pageForm__1L9O+"};